import React from "react";
import { ManageProductFaq } from "../../components/ProductManager/ProductFaq/ManageProductFaq";
import { ToastContainer } from "react-toastify";
export const ManageProductFaqPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageProductFaq />
        </div>
      </div>
    </div>
  );
};
